import { render, staticRenderFns } from "./TheModeB.vue?vue&type=template&id=0745688c&scoped=true&"
import script from "./TheModeB.vue?vue&type=script&lang=js&"
export * from "./TheModeB.vue?vue&type=script&lang=js&"
import style0 from "./TheModeB.vue?vue&type=style&index=0&id=0745688c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0745688c",
  null
  
)

component.options.__file = "TheModeB.vue"
export default component.exports